// Enhanced Quick Add Form Handler
document.addEventListener('DOMContentLoaded', function() {
  // Handle quick add form submissions
  document.addEventListener('submit', function(e) {
    if (e.target.classList.contains('quick-add-form')) {
      e.preventDefault();
      
      const form = e.target;
      const button = form.querySelector('.quick-add__submit');
      const textSpan = button.querySelector('.add-to-cart-text');
      const spinner = button.querySelector('.loading-spinner');
      const variantId = form.querySelector('input[name="id"]').value;
      
      // Disable button and show loading state
      button.disabled = true;
      textSpan.textContent = 'ADDING...';
      spinner.style.display = 'inline';
      spinner.classList.remove('hidden');
      
      // Create form data
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      
      // Submit via fetch to cart/add.js for better error handling
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        // Success - update cart and show feedback
        textSpan.textContent = 'ADDED!';
        
        // Update cart count if cart drawer exists
        updateCartCount();
        
        // Reset button after 2 seconds
        setTimeout(() => {
          button.disabled = false;
          textSpan.textContent = 'ADD TO CART';
          spinner.style.display = 'none';
          spinner.classList.add('hidden');
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Show error state
        textSpan.textContent = 'ERROR - TRY AGAIN';
        
        // Reset button after 3 seconds
        setTimeout(() => {
          button.disabled = false;
          textSpan.textContent = 'ADD TO CART';
          spinner.style.display = 'none';
          spinner.classList.add('hidden');
        }, 3000);
      });
    }
  });
  
  // Function to update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart icon bubble if it exists
        const cartBubble = document.querySelector('.cart-count-bubble');
        if (cartBubble) {
          cartBubble.textContent = cart.item_count;
          if (cart.item_count > 0) {
            cartBubble.style.display = 'flex';
          }
        }
        
        // Update any other cart count displays
        const cartCounts = document.querySelectorAll('.cart-count');
        cartCounts.forEach(count => {
          count.textContent = cart.item_count;
        });
        
        // Trigger cart drawer update if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart?section_id=cart-drawer')
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCartDrawer = doc.querySelector('cart-drawer');
              if (newCartDrawer) {
                cartDrawer.innerHTML = newCartDrawer.innerHTML;
              }
            })
            .catch(err => console.log('Cart drawer update failed:', err));
        }
      })
      .catch(err => console.log('Cart count update failed:', err));
  }
});

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
